export default __webpack_public_path__ + "static/media/NoelHardstyle.e66197ea.mp3";